import FileUploadIcon from "@mui/icons-material/FileUpload";
import { Button, Tooltip, Stack, Typography, Link } from "@mui/material";
import { VisuallyHiddenInput } from "../helpers/VisuallyHiddenInput";

export default function FileControl(props) {
  // const fileInputRef1 = useRef(null);
  return (
    <Stack spacing={1}>
      {props.value.hasOwnProperty("url") ? (
        <Link
          color="secondary"
          disabled
          href={
            props.value.hasOwnProperty("url") ? props.value.url : "#"
          }
          underline="none"
          style={{ marginLeft: 6 }}
        >{`${
          props.value !== undefined && props.value.name !== undefined
            ? props.value.name
            : " "
        }`}</Link>
      ) : (
        <Typography color="secondary" style={{ marginLeft: 6 }}>{`${
          props.value.name !== undefined ? props.value.name : " "
        }`}</Typography>
      )}

      <Tooltip title="Upload File">
        <Button
          color="primary"
          component="label"
          role={undefined}
          variant="contained"
          tabIndex={-1}
          startIcon={<FileUploadIcon />}
        >
          Upload file
          <VisuallyHiddenInput
            type="file"
            // ref={fileInputRef}
            onChange={(event) =>
              event.target.files.length > 0 &&
              props.onChange(props.id, event.target.files[0])
            }
          />
        </Button>
      </Tooltip>
    </Stack>
  );
}
